import { createFileRoute, notFound, redirect } from '@tanstack/react-router';
import { domAnimation, LazyMotion } from 'motion/react';

import { ErrorNotFound } from '#features/error/components/ErrorNotFound';
import { MainLayout } from '#features/layout/components/MainLayout';
import { defaultLocale, isLocaleValid } from '#features/i18n';
import { getPathnamePrefix } from '#features/i18n/utils/getPathnamePrefix';

export const Route = createFileRoute('/{-$locale}')({
  // С шапкой и подвалом, как на корневом маршруте: локализованный несуществующий адрес
  // (`/ru/nope`) разбирается здесь, и голый экран ошибки выпадал бы из сайта.
  notFoundComponent: () => (
    <LazyMotion features={domAnimation}>
      <MainLayout plain>
        <ErrorNotFound />
      </MainLayout>
    </LazyMotion>
  ),
  beforeLoad: async ({ params, search, context }) => {
    const locale = context.i18n.locale;
    const paramLocale = params.locale ?? defaultLocale;

    if (!isLocaleValid(paramLocale)) {
      throw notFound({ routeId: '__root__' });
    }

    if (locale && locale !== paramLocale) {
      throw redirect({
        to: '.',
        params: { ...params, locale: getPathnamePrefix(locale) },
        search,
        reloadDocument: true,
      });
    }
  },
});
